function mobileNav(){
  const navButtons = [...document.querySelectorAll('[data-nav="button"]')];
  const navMenu = document.querySelector('[data-nav="menu"]');

  if(!navButtons?.length || !navMenu) {
    console.log('Mobile nav elements not found');
    return;
  };

  navButtons.forEach(button => {
    button.addEventListener('click', () => {
      console.log('lcick')
      if(navMenu.dataset.active === 'true') {
        navMenu.dataset.active = 'false';
        return;
      }
      navMenu.dataset.active = 'true';

      const navLinks = [...navMenu.querySelectorAll('a[href]')];
      navLinks[0].focus();
    });
  });

};

export { mobileNav }